import { gql } from "@apollo/client";

export const FETCH_DOCUMENT = gql`
    query FetchDocument($id: ID!) {
        officialDocument(id: $id) {
            id
            reference
            name
            category
            hoverTitle
            pdfUrl
            pdfFileUrl
            rootContentNode {
                id
                type
                text
                metadata
                sizeInTokens
                childNodes {
                    id
                    type
                    text
                    metadata
                    sizeInTokens
                    sizeInPages
                    associatedOfficialDocument {
                        id
                        reference
                        name
                    }
                }
                associatedOfficialDocument {
                    id
                    reference
                    name
                    category
                    hoverTitle
                }
            }
        }
    }
`;
